import { useTranslation } from 'react-i18next';
import {
  Button,
  ResultContent,
  ModalComponentWrapper,
} from '@/shared/components';
import { useModalStore } from '@/shared/lib';

const useExchangeResult = () => {
  const { t } = useTranslation();
  const { showDialogComponent, closeDialog } = useModalStore();

  const goToSuccessScreen = () => {
    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess
            title={t('exchange.successTitle')}
            description={t('exchange.successDescription')}
            showButton={false}
            className="h-auto">
            <Button
              size="lg"
              variant="secondary"
              onClick={() => {
                closeDialog();
              }}
              className="w-full headline4 mb-[1.6rem]">
              {t('exchange.makeAnotherExchange')}
            </Button>
            <Button
              size="lg"
              variant="secondary"
              onClick={() => {
                closeDialog();
                window.location.href = '/';
              }}
              className="w-full headline4">
              {t('exchange.goToMainPage')}
            </Button>
          </ResultContent>
        </ModalComponentWrapper>
      ),
    });
  };

  const goToErrorScreen = () => {
    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess={false}
            onClick={() => {
              closeDialog();
            }}
            title={t('exchange.errorTitle')}
            description={t('exchange.errorDescription')}
            buttonText={t('common.close')}
            buttonVariant="secondary"
          />
        </ModalComponentWrapper>
      ),
    });
  };

  return {
    goToSuccessScreen,
    goToErrorScreen,
  };
};

export { useExchangeResult };
